import { render } from "./ErrorLicenseAdminNoLicense.vue?vue&type=template&id=861a02a8&scoped=true"
import script from "./ErrorLicenseAdminNoLicense.vue?vue&type=script&lang=js"
export * from "./ErrorLicenseAdminNoLicense.vue?vue&type=script&lang=js"

import "./ErrorLicenseAdminNoLicense.vue?vue&type=style&index=0&id=861a02a8&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-861a02a8"]])

export default __exports__